<template>
  <van-popup
      v-model:show="showPopup"
      position="bottom"
      :style="{ width: '100%' }"
      round
      :overlay-style="{ backgroundColor: 'transparent' }"
      :close-on-click-overlay="true"
      @click-overlay="closePopup"
  >
    <div class="sticker-card" @click.stop="closePopup">
      <div class="card-content">
        <h3 class="card-title">{{ $i18n(currentContent.titleKey, currentContent.titleFallback) }}</h3>
        <p class="card-subtitle">{{ $i18n(currentContent.subtitleKey, currentContent.subtitleFallback) }}</p>
        <button class="card-button" @click="handleSend">
          {{ $i18n(currentContent.buttonTextKey, currentContent.buttonTextFallback) }}
        </button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { getRandom } from "@utils";
import { Popup } from "vant";
import {mapGetters} from "vuex";
import i18nMixin from "@/libs/i18nMixin";
export default {
  name: 'StickerPopup',
  mixins: [i18nMixin],
  components: {
    VanPopup: Popup,
  },
  data() {
    return {
      showPopup: false,
      autoCloseTimer: null,
      currentContent: {},
      contents: [
        {
          titleKey: 'sendBusinessCard',
          titleFallback: '发名片',
          subtitleKey: 'findPartners',
          subtitleFallback: '快速寻找合作伙伴',
          buttonTextKey: 'sendNow',
          buttonTextFallback: '立即发送',
          type: 'card'
        },
        {
          titleKey: 'shareResources',
          titleFallback: '发资源',
          subtitleKey: 'shareResourcesDesc',
          subtitleFallback: '分享资源,赚钱现金红包奖励',
          buttonTextKey: 'shareNow',
          buttonTextFallback: '立即分享',
          type: 'resource'
        },
        {
          titleKey: 'sendRedPacket',
          titleFallback: '发红包',
          subtitleKey: 'attractAttention',
          subtitleFallback: '快速吸引关注',
          buttonTextKey: 'sendNow',
          buttonTextFallback: '立即发送',
          type: 'redPacket'
        },
        {
          titleKey: 'sendPhoto',
          titleFallback: '发照片',
          subtitleKey: 'shareMoments',
          subtitleFallback: '分享美好瞬间',
          buttonTextKey: 'shareNow',
          buttonTextFallback: '立即分享',
          type: 'photo'
        },
        {
          titleKey: 'sendBlessings',
          titleFallback: '发祝福',
          subtitleKey: 'sendBlessingsDesc',
          subtitleFallback: '发Ai祝福,送礼物特效',
          buttonTextKey: 'sendNow',
          buttonTextFallback: '立即发送',
          type: 'wish'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["userInfo","live"]),
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.$store.dispatch('live/getLiveInfo', this.live.id);
      // await this.checkCardStatus();
    });
  },
  methods: {
    async checkCardStatus() {
      const res = await this.$http.get("/live/checkCard", {
        params: { id: this.live.id }
      });
      const hasSend = !!res.data;
      if(!hasSend){
        this.initPopup();
      }
    },
    initPopup() {
      // const hasSendCard = !!this.userInfo.hasSendCard;
      // if(!hasSendCard){
        this.showPopup = true;
        this.selectRandomContent();
        this.startAutoClose();
      // }
    },
    selectRandomContent() {
      console.log('活动设置',JSON.stringify(this.live.liveConfig));
      // 聊天和推广会
      // 聊天和推广会
      if(this.live.liveConfig.liveTypeCode==='chat_group'||this.live.liveConfig.liveTypeCode==='meeting_sales'){
        this.currentContent = this.contents[0];
      }else if(this.live.liveConfig.liveTypeCode==='wedding'){
        this.currentContent = this.contents[4];
      }else{
        const randomIndex = Math.floor(Math.random() * this.contents.length);
        this.currentContent = this.contents[randomIndex];
      }
    },

    startAutoClose() {
      this.autoCloseTimer = setTimeout(() => {
        this.closePopup();
        console.log(this.$i18n('autoClosePopup', '自动关闭弹窗'));
      }, 20000);
    },

    handleSend() {
      this.$emit('content-selected', this.currentContent);
      this.closePopup();
    },

    closePopup() {
      this.showPopup = false;
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  },
  beforeUnmount() {
    clearTimeout(this.autoCloseTimer);
  }
};
</script>

<style lang="less" scoped>
.sticker-card {
  background: #fff;
  border-radius: 8px;  /* 原16px */
  padding: 20px;  /* 原40px */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);  /* 原8px 24px */

  .card-content {
    position: relative;

    .card-title {
      font-size: 18px;  /* 原36px */
      color: #000;
      font-weight: 600;
      margin-bottom: 6px;  /* 原12px */
    }

    .card-subtitle {
      font-size: 14px;  /* 原28px */
      color: #666;
      margin-bottom: 8px;  /* 原16px */
    }

    .card-button {
      position: absolute;
      right: 5px;  /* 原10px */
      top: 50%;
      transform: translateY(-50%);
      padding: 12px;  /* 原24px */
      background: #28c76f;
      color: white;
      border: none;
      border-radius: 4px;  /* 原8px */
      font-size: 13px;  /* 原26px */
      cursor: pointer;
      transition: background 0.3s ease;
    }

    .card-button:hover {
      background: #25a362;
    }
  }
}
</style>
